<template>
	<div class="box">
		<!-- <div class="title">我的账号</div> -->
		<div class="company">
			<div class="name">{{ createForm.customerName }}

				<span class="tips"> 有效期至：{{ time }}</span>
			</div>
		</div>
		<div class="content2">
			<Form :model="createForm" :label-width="100" inline class="create-form" :rules="createRules">
				<FormItem style='width: 45%;' label="姓名：" prop="nickname">
					<Input v-model="createForm.nickname" disabled placeholder="请输入"></Input>
					<!-- <span>{{ createForm.nickname }} </span> -->
				</FormItem>
				<FormItem style='width: 45%;' label="邮箱：" prop="email">
					<Input v-model="createForm.email" placeholder="请输入"></Input>
					<!-- <span>{{ createForm.email }} </span> -->
				</FormItem>
				<FormItem style='width: 45%;' label="手机号：" prop="phone">
					<Input v-model="createForm.phone" disabled style="width:100%"></Input>
					<!-- <span>{{ createForm.phone }} </span> -->
				</FormItem>
				<FormItem style='width: 45%;' label="密码：" prop="password">
					<Input v-model="createForm.password" type="password" disabled placeholder="******">

					<span slot="suffix" class="xiugai" @click="showModal = true"> 修改密码</span>
					</Input>
					<!-- <span>{{ createForm.password }} </span> -->
					<!-- <Button type="info" style="width: 20%;" @click="showModal = true">修改密码</Button> -->
				</FormItem>
				<!-- <FormItem style='width: 45%;' prop="userWechat">
					<Button type="info" style="width: 140px;height: 40px;" @click="save">保存</Button>
				</FormItem> -->
				<!-- 	<div style="text-align: left">
					<Button type="primary" style="width: 144px" @click="save">保存</Button>
				</div> -->
			</Form>
		</div>
		<Modal v-model="showModal" class-name="vertical-center-modal" title='修改密码' footer-hide
			@on-cancel="cancelModalHandle" width="416">
			<div class="modalContent">
				<Form :model="formItem" :label-width="90">
					<FormItem label="原密码">
						<Input v-model="formItem.lastpsw" password type="password" placeholder="原密码"></Input>
					</FormItem>
					<FormItem label="新密码">
						<Input v-model="formItem.psw" password type="password" placeholder="新密码"></Input>
					</FormItem>
					<FormItem label="确认新密码">
						<Input v-model="formItem.psw2" password type="password" placeholder="确认新密码"></Input>
					</FormItem>
				</Form>
				<div style="width: 141px; margin: 40px auto">
					<Button :loading="loading" @click.native.prevent="handleSetPsw" type="info"
						style="width: 140px;height: 40px; background-color: #045AFC;" class="setPsw" circle>确定</Button>
				</div>
			</div>
		</Modal>
	</div>
</template>
<script>
import {
	getDetail,
	repetition,
	update,
	updatepsw,
	getverify,
} from "@/api/MyAccount";
import dayjs from 'dayjs'

import {
	mapMutations,
	mapState
} from "vuex";
import {
	formatTime,
	formatDate
} from "@/utils/index";
export default {
	data() {
		return {
			showModal: false,
			birthday: '',
			createForm: {
				email: "",
				gmtCreate: 0,
				id: 1,
				nickname: "",
				phone: "",
				pidName: "",
				sex: "",
				userAduiltResult: "",
				userCreater: "",
				userDepartment: "",
				userType: "",
				userWechat: "",
				userWorktime: "",
				username: "",
				state: "",
				birthday: '',
			},
			userTypeArr: [{
				userType: 1,
				userTypeName: "用户管理员",
			},
			{
				userType: 2,
				userTypeName: "普通用户",
			},
			{
				userType: 3,
				userTypeName: "独立管理员",
			},
			],
			loading: false,
			loading2: false,
			formItem: {
				lastpsw: "",
				psw: "",
				psw2: "",
				code: "",
			},
			genderList: [{
				value: "0",
				label: "男",
			},
			{
				value: "1",
				label: "女",
			},
			],
			createRules: {
				nickname: [{
					required: false,
					message: "此项必填",
					trigger: "blur"
				}],
				password: [{
					required: false,
					message: "此项必填",
					trigger: "blur"
				}],
				username: [{
					required: false,
					message: "此项必填",
					trigger: "blur"
				}],
				sex: [{
					required: false,
					message: "此项必填",
					trigger: "blur"
				}],
				userDepartment: [{
					required: false,
					message: "此项必填",
					trigger: "blur"
				},],
				userWorktime: [{
					required: false,
					message: "此项必填",
					trigger: "blur"
				},],
				phone: [{
					required: false,
					message: "此项必填",
					trigger: "blur"
				}],
				status: [{
					required: false,
					message: "此项必填",
					trigger: "blur"
				}],
			},
			sec: 0,
		};
	},
	computed: {
		...mapState(["userId", "user"]),
		time() {
			return dayjs(this.createForm.customerAccountEndDate).format('YYYY/MM/DD')
				;

		},
		timeDifference() {
			return parseInt(
				(new Date(this.createForm.customerAccountEndDate).getTime() -
					new Date().getTime()) /
				1000 /
				(24 * 60 * 60)
			);
		},
		type() {
			let usr = this.userTypeArr.filter((i) => {
				return i.userType == this.createForm.userType;
			});
			return usr[0].userTypeName;
		},
		customerInfo() {
			return JSON.parse(localStorage.getItem('customerInfo'))
		},
		showTrial() {
			let state = false
			if (this.customerInfo.customerState == 0 || this.customerInfo.customerState == 3) {
				state = true
			}
			return state
		}

	},
	methods: {
		...mapMutations(["changeState"]),
		changeBirthday(e) {
			this.createForm.birthday = e
		},
		uploadLogo() {
			document.getElementById("btn_file").click()
		},
		sendCode() {
			this.loading2 = true;
			this.timer = setInterval(() => {
				if (this.sec > 1) {
					this.sec--;
				} else {
					this.sec = 60;
					clearInterval(this.timer);
				}
			}, 1000);
			getverify({
				username: this.createForm.username,
			})
				.then((res) => {
					this.loading2 = false;
					return this.$msg.success({
						text: "验证码已发送"
					});
					// this.$msg.success("验证码已发送");
				})
				.catch((err) => {
					this.loading2 = false;
					this.$msg.error({
						text: err.data
					});
				});
		},
		checkRepetition() {
			if (!this.createForm.nickname) {
				return this.$msg.error({
					text: "请输入用户账号"
				});
				// return this.$msg.error("请输入用户账号");
			}
			repetition({
				username: this.createForm.nickname,
			}).then((res) => {
				// this.$msg.success("此账号可使用")
				this.$msg.success({
					text: "此账号可使用"
				});
			});
		},
		save() {
			let params = {
				email: this.createForm.email,
				id: this.userId,
				userWechat: this.createForm.userWechat,
				userLogo: this.createForm.userLogo,
				sex: this.createForm.sex,
				birthday: this.createForm.birthday,
				userDepartment: this.createForm.userDepartment
			}
			update(params).then((res) => {
				// this.$msg.success("修改成功");
				this.$msg.success({
					text: "修改成功"
				});
				this.changeState({
					prop: "user",
					value: Object.assign(this.user, {
						userLogo: this.createForm.userLogo,
					}),
				});
			})
				.catch((err) => {
					this.$msg.error({
						text: err.data
					});
				});
		},
		async init() {
			getDetail(this.userId).then((res) => {
				this.createForm = res;
				this.birthday = this.createForm.birthday ? this.createForm.birthday : ''
			}).catch((err) => {

			})
				;
		},
		blobToDataURL(blob, cb) {
			let reader = new FileReader();
			reader.onload = function (evt) {
				var base64 = evt.target.result;
				cb(base64);
			};
			reader.readAsDataURL(blob);
		},
		changeImg(event) {
			let img = event.target.files[0];
			let that = this;
			if (img) {
				var url = URL.createObjectURL(img);
				var base64 = this.blobToDataURL(img, function (base64Url) {
					that.createForm.userLogo = base64Url;
				});
			}
		},
		handleSetPsw() {
			if (!this.formItem.lastpsw.trim())
				return this.$msg.error({
					text: "请输入原密码"
				});
			if (!this.formItem.psw.trim())
				return this.$msg.error({
					text: "请输入新密码"
				});
			if (this.formItem.psw.trim() !== this.formItem.psw2.trim())
				return this.$msg.error({
					text: ["两次输入的新密码", "不一致", "，请重新输入。"],
				});
			// if (!this.formItem.code.trim())
			// 	return this.$msg.success({
			// 		text: "请输入验证码"
			// 	});
			updatepsw({
				userId: this.userId,
				rawPassword: this.formItem.lastpsw.trim(),
				newPassword: this.formItem.psw.trim(),
				// verifyCode: this.formItem.code.trim(),
			})
				.then((res) => {
					// this.$msg.success("修改成功")

					this.$msg.success({
						text: "密码重置成功，请重新登录。"
					});
					setTimeout(() => {
						this.changeState({
							prop: "token",
							value: "",
						});
						localStorage.setItem("token", "");
						localStorage.setItem("isLogin", false);
						localStorage.setItem("userId", "");
						window.location.reload();
					}, 3000);
				})
				.catch((err) => {
					this.$msg.error({
						text: err.data
					});
				});
		},
		cancelModalHandle() {
			this.formItem.psw = "";
			this.formItem.psw2 = "";
		},
	},
	mounted() {
		this.init();
	},
};
</script>

<style scoped lang="scss">
.box {
	// width: 100%;
	height: 100%;
	// padding: 24px;
	box-sizing: border-box;
	background-color: #fff;
	border-radius: 10px;
	margin: 24px;

	.title {
		font-size: 24px;
		font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
		font-weight: bold;
		color: rgba(51, 51, 51, 1);
		border-bottom: 1px solid #d6d7d9;
		height: 50px;
		line-height: 30px;
	}

	.company {
		width: 100%;
		position: relative;
		margin-top: 20px;
		height: 154px;


		.trial {
			position: absolute;
			top: -53px;
			left: -49px;
		}

		.logo {
			width: 60px;
			height: 60px;
			display: block;
			position: absolute;
			top: 45px;
			left: 106px;
			background: #eee;
		}

		.name {
			height: 21px;
			font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
			font-weight: bold;
			font-family: Source Han Sans CN;
			font-weight: bold;
			font-size: 30px;
			color: #000000;
			line-height: 46px;
			line-height: 21px;
			position: absolute;
			top: 107px;
			left: 110px;
		}

		.tips {
			font-family: Source Han Sans CN;
			font-weight: 500;
			font-size: 14px;
			color: #92969B;
			line-height: 46px;
			margin-left: 4px;
		}

		.time1,
		.time2,
		.time3 {
			height: 19px;
			font-size: 14px;
			font-family: MicrosoftYaHei;
			color: rgba(153, 153, 153, 1);
			line-height: 19px;
			position: absolute;
			top: 107px;

		}

		.time1 {
			left: 200px;
		}

		.time2 {
			left: 241px;
		}

		.time3 {
			left: 620px;
		}
	}

	.manager {
		margin-top: 40px;
		padding: 0 100px;

		.header {
			width: 60px;
			height: 60px;
			background: #eee;
			margin-right: 10px;
			margin-left: 6px;
		}

		.nameBox {
			display: inline-block;
			font-size: 24px;
			font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
			font-weight: bold;
			color: rgba(51, 51, 51, 1);
			margin-right: 10px;
			margin-left: 10px;

			.type {
				font-size: 14px;
				font-weight: 400;
				padding: 4px;
				border-radius: 8px;
				color: #999999;
				background-color: rgba($color: #999999, $alpha: 0.1);
				width: auto;
				text-align: center;
				display: inline-block;
			}
		}

		.upload {
			position: relative;
			overflow: hidden;

			input {
				/* position: absolute; */
				/* 					left: 0;
					top: 0; */
				opacity: 0;
				pointer-events: none;
				cursor: pointer;
			}
		}
	}

	.content2 {
		padding: 30px 70px;
		width: 1100px;

		.create-form {
			width: 100%;

			.row {
				width: 100%;
				height: 30px;
				margin-bottom: 20px;
				display: flex;
				justify-content2: space-between;
				align-items: center;

				.col {
					flex: 1;
				}
			}
		}
	}
}

/deep/.ivu-input[disabled],
fieldset[disabled] .ivu-input {
	color: #333333;
}

/deep/.vertical-center-modal {
	display: flex;
	align-items: center;
	justify-content2: center;

	.ivu-modal {
		top: 0;
	}
}

.xiugai {
	font-family: Source Han Sans CN;
	font-weight: 500;
	font-size: 12px;
	color: #0459FC;
	// line-height: 64px;
	position: absolute;
	width: 70px;
	right: 9px;
	top: 7px;
	cursor: pointer;
}

::v-deep.ivu-input-prefix,
.ivu-input-suffix {
	width: 65px;

}

::v-deep.ivu-input-suffix {

	width: 65px;

}
</style>
